<h3>{{title}}</h3>
<mat-dialog-content>
  <div class="intro-text" style="margin-top:20px;margin-bottom: 30px;max-width:400px" [innerHTML]="message">
  </div>
  @if (dateDialog) {
    <div>
      <app-utc-date-picker></app-utc-date-picker>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  @if (allowCancel) {
    <div class="text-center" style="flex-grow: 1">
      <button class="btn btn-default btn-round btn-round-sm" mat-dialog-close>
        <i class="fa fa-close"></i>
      </button>
      <div class="btn-text">{{ data.cancelText || 'No' }}</div>
    </div>
  }

  @if (allowNext) {
    <div class="text-center" style="flex-grow: 1">
      <button class="btn btn-primary btn-round btn-round-sm" [mat-dialog-close]="true"><i
      class="fa fa-check"></i></button>
      <div class="btn-text">{{ data.confirmText || 'Yes' }}</div>
    </div>
  }

</mat-dialog-actions>